var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporationCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202.888,
    height: 202.16,
    viewBox: "0 0 202.888 202.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3004",
    "data-name": "Group 3004",
    transform: "translate(-9452.5 -1752.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-50",
    transform: "translate(9459.109 1752.35)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 20.999,
    cy: 20.999,
    r: 20.999,
    transform: "matrix(0.079, -0.997, 0.997, 0.079, 71.126, 41.865)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 19.001,
    cy: 19.001,
    r: 19.001,
    transform: "translate(74.94 3.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2905",
    "data-name": "Path 2905",
    d: "M203.1,51.258v1.89c0,.231.044.515.065.807s.057.6.087.938a10.477,10.477,0,0,0,.179,1.056,18.256,18.256,0,0,0,1.772,5.2,19.014,19.014,0,0,0,4.477,5.708l.781.663c.275.209.567.4.873.607s.572.436.873.6l.956.537c.161.092.323.183.489.271l.511.227,1.043.463c.358.14.733.244,1.1.371a9.723,9.723,0,0,0,1.135.336,18.3,18.3,0,0,0,2.378.436c.41.039.82.109,1.235.127h1.9l.637-.057c.436-.044.873-.065,1.309-.127a19.388,19.388,0,0,0,2.562-.554l.646-.188.323-.1.314-.127,1.266-.511c.415-.192.812-.436,1.226-.628.2-.113.415-.205.611-.332l.585-.384A21.426,21.426,0,0,0,234.7,66.8l1.034-1,.257-.249.24-.275.471-.554.484-.559.436-.6.436-.6.209-.305c.065-.1.122-.214.183-.319l.733-1.309c.2-.436.406-.912.607-1.37a20.344,20.344,0,0,0,1.37-5.922,20.126,20.126,0,0,0-.615-6.031q-.21-.729-.436-1.44c-.188-.463-.371-.921-.559-1.379l-.14-.345-.17-.327-.34-.655-.34-.65-.4-.611-.4-.611-.2-.3-.223-.284-.873-1.126a21.633,21.633,0,0,0-2.034-1.972l-.532-.436c-.175-.153-.375-.271-.563-.41-.38-.257-.746-.537-1.135-.781l-1.187-.672-.292-.166c-.1-.052-.205-.1-.31-.14l-.615-.275a20.39,20.39,0,0,0-2.479-.908c-.436-.113-.847-.192-1.266-.288l-.624-.14c-.209-.044-.436-.057-.633-.083l-1.252-.148c-.436-.035-.829,0-1.239-.035a17.761,17.761,0,0,0-2.422.122,9.517,9.517,0,0,0-1.165.183c-.38.079-.768.131-1.139.227l-1.091.319-.541.157-.515.205-1.017.41a10.414,10.414,0,0,0-.964.476c-.31.166-.628.319-.93.489l-.873.559a18.935,18.935,0,0,0-5.184,5.075,18.2,18.2,0,0,0-2.444,4.923c-.109.362-.253.694-.319,1.026s-.14.633-.205.916-.131.545-.175.79-.057.467-.079.663q-.079.589-.118.9c-.026.2-.048.305-.048.305a2.75,2.75,0,0,1,.026-.31c.026-.205.052-.511.1-.9a6.574,6.574,0,0,1,.07-.668c.026-.231.1-.506.166-.794l.2-.925a10.732,10.732,0,0,1,.31-1.03,18.246,18.246,0,0,1,2.422-4.966,19.1,19.1,0,0,1,5.2-5.132l.873-.563c.305-.175.624-.332.938-.5a8.724,8.724,0,0,1,.969-.484l1.021-.436.524-.205.541-.161,1.1-.327c.375-.1.764-.153,1.148-.231a10.516,10.516,0,0,1,1.178-.188,18.014,18.014,0,0,1,2.439-.127c.415,0,.833,0,1.252.031l1.266.144c.209.031.436.044.637.083l.633.14c.436.1.851.175,1.279.292a20.073,20.073,0,0,1,2.509.912l.624.275.31.14.3.17,1.2.676c.393.244.764.528,1.152.79.188.14.388.257.567.415l.537.458a21.537,21.537,0,0,1,2.051,1.994l.908,1.139.227.284.2.305.4.615.4.62.345.659.345.659.175.332.14.345.563,1.4c.144.484.288.969.436,1.453a19.006,19.006,0,0,1-.794,12.1l-.615,1.388-.742,1.309c-.061.109-.118.218-.183.323l-.214.305-.436.611-.436.607-.48.559-.476.559-.24.279-.262.253-1.047,1.008a21.413,21.413,0,0,1-2.3,1.7l-.594.384c-.192.131-.41.223-.615.336-.415.214-.82.436-1.244.633l-1.279.515-.314.127c-.109.039-.218.065-.327.1l-.65.192a21.325,21.325,0,0,1-2.618.576c-.436.061-.873.079-1.309.122l-.646.057h-1.916c-.436-.026-.833-.092-1.248-.135a17.8,17.8,0,0,1-2.4-.436,9.879,9.879,0,0,1-1.143-.34c-.371-.131-.751-.236-1.108-.38l-1.052-.467-.515-.231-.493-.275-.96-.545q-.451-.279-.873-.6c-.292-.209-.585-.406-.873-.615l-.786-.672a19.106,19.106,0,0,1-4.486-5.769,18.19,18.19,0,0,1-1.746-5.237,10.476,10.476,0,0,1-.175-1.06c-.026-.336-.052-.65-.074-.943s-.052-.563-.057-.812,0-.467,0-.668a8.646,8.646,0,0,1,.026-.912C203.09,51.381,203.1,51.258,203.1,51.258Z",
    transform: "translate(-128.355 -30.011)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2906",
    "data-name": "Path 2906",
    d: "M255.5,63.678a4.194,4.194,0,0,1-.676.044l-1.855.039c-1.58,0-3.775.035-6.254.039h-.122V62.438c0-2.771,0-5.276.035-7.091,0-.873.031-1.6.039-2.147a4.6,4.6,0,0,1,.048-.79,4.6,4.6,0,0,1,.048.79c0,.55.022,1.274.039,2.147.022,1.815.035,4.32.035,7.091v1.239l-.122-.122c2.479,0,4.674,0,6.254.039l1.855.039a3.636,3.636,0,0,1,.676.044Z",
    transform: "translate(-152.903 -40.768)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2907",
    "data-name": "Path 2907",
    d: "M246.824,40.27a5.237,5.237,0,0,1,.127,1.606,5.19,5.19,0,0,1-.127,1.606,5.445,5.445,0,0,1-.122-1.606A5.468,5.468,0,0,1,246.824,40.27Z",
    transform: "translate(-152.958 -33.926)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2908",
    "data-name": "Path 2908",
    d: "M264.086,46.18a5.237,5.237,0,0,1-1.047,1.231,5.237,5.237,0,0,1-1.209,1.03,5.145,5.145,0,0,1,1.034-1.2,5.145,5.145,0,0,1,1.222-1.056Z",
    transform: "translate(-161.492 -37.257)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2909",
    "data-name": "Path 2909",
    d: "M275.147,58.93a6.817,6.817,0,0,1-1.309.873,6.567,6.567,0,0,1-1.388.764,6.947,6.947,0,0,1,2.7-1.636Z",
    transform: "translate(-167.478 -44.443)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2910",
    "data-name": "Path 2910",
    d: "M279.834,77.688a19.66,19.66,0,0,1-4.364,0,18.988,18.988,0,0,1,4.364,0Z",
    transform: "translate(-169.18 -54.943)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2911",
    "data-name": "Path 2911",
    d: "M210.557,77a17.569,17.569,0,0,1-4.137,0,17.57,17.57,0,0,1,4.137,0Z",
    transform: "translate(-130.263 -54.55)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M216.582,91.26a8.924,8.924,0,0,1-1.562,1.418A9.164,9.164,0,0,1,213.3,93.9a9.125,9.125,0,0,1,1.562-1.418A8.929,8.929,0,0,1,216.582,91.26Z",
    transform: "translate(-134.141 -62.664)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M230.165,102.15A13.867,13.867,0,0,1,229.1,104a13.8,13.8,0,0,1-1.13,1.8,7.056,7.056,0,0,1,.916-1.929A6.9,6.9,0,0,1,230.165,102.15Z",
    transform: "translate(-142.409 -68.802)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2914",
    "data-name": "Path 2914",
    d: "M246.824,110.564a19.54,19.54,0,0,1,0-4.364,18.874,18.874,0,0,1,0,4.364Z",
    transform: "translate(-152.958 -71.084)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2915",
    "data-name": "Path 2915",
    d: "M264.4,105.828a6.467,6.467,0,0,1-1.807-1.239,6.38,6.38,0,0,1-1.471-1.619,19.308,19.308,0,0,1,1.637,1.436,19.469,19.469,0,0,1,1.641,1.423Z",
    transform: "translate(-161.092 -69.264)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2916",
    "data-name": "Path 2916",
    d: "M275.263,95.067a7.581,7.581,0,0,1-1.449-1.279,7.458,7.458,0,0,1-1.274-1.449,14.923,14.923,0,0,1,2.723,2.727Z",
    transform: "translate(-167.529 -63.273)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2917",
    "data-name": "Path 2917",
    d: "M217.277,60.607a5.974,5.974,0,0,1-1.283-1.1,5.856,5.856,0,0,1-1.1-1.283,11.9,11.9,0,0,1,2.387,2.387Z",
    transform: "translate(-135.037 -44.042)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2918",
    "data-name": "Path 2918",
    d: "M229.859,47.469a5.565,5.565,0,0,1-1.257-1.087,5.59,5.59,0,0,1-1.082-1.252,5.708,5.708,0,0,1,1.257,1.078,5.7,5.7,0,0,1,1.082,1.261Z",
    transform: "translate(-142.155 -36.665)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2919",
    "data-name": "Path 2919",
    d: "M205.255,52.921a19,19,0,0,1,17.869-18.966c-.37,0-.749-.035-1.129-.035a19,19,0,1,0,0,38.008c.38,0,.759,0,1.13-.041A19,19,0,0,1,205.255,52.921Z",
    transform: "translate(-128.33 -30.347)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    "data-name": "Rectangle 986",
    width: 57.966,
    height: 91.608,
    transform: "translate(133.185 34.941)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    width: 54.645,
    height: 88.383,
    transform: "translate(134.747 36.661)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_988",
    "data-name": "Rectangle 988",
    width: 21.789,
    height: 33.812,
    transform: "translate(162.07 41.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2920",
    "data-name": "Path 2920",
    d: "M428.8,127.342a.816.816,0,1,1-.812-.812.816.816,0,0,1,.812.812Z",
    transform: "translate(-254.679 -82.542)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_989",
    "data-name": "Rectangle 989",
    width: 21.789,
    height: 33.812,
    transform: "translate(140.111 85.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2921",
    "data-name": "Path 2921",
    d: "M378.482,226.386a.812.812,0,1,1-.236-.577.816.816,0,0,1,.236.577Z",
    transform: "translate(-226.318 -138.362)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_990",
    "data-name": "Rectangle 990",
    width: 18.608,
    height: 26.402,
    transform: "translate(139.814 41.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2922",
    "data-name": "Path 2922",
    d: "M373.413,126.126a.672.672,0,1,1-.2-.48.676.676,0,0,1,.2.48Z",
    transform: "translate(-223.619 -81.934)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991",
    "data-name": "Rectangle 991",
    width: 20.03,
    height: 11.097,
    transform: "translate(164.679 87.732) rotate(-6.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 0.69,
    cy: 0.69,
    r: 0.69,
    transform: "translate(174.171 88.024)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2923",
    "data-name": "Path 2923",
    d: "M376.5,238.051c0,.087-3.421.161-7.641.161s-7.641-.074-7.641-.161,3.417-.161,7.641-.161S376.5,237.96,376.5,238.051Z",
    transform: "translate(-217.509 -145.305)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2924",
    "data-name": "Path 2924",
    d: "M376.5,243.591c0,.092-3.421.161-7.641.161s-7.641-.07-7.641-.161,3.417-.161,7.641-.161S376.5,243.5,376.5,243.591Z",
    transform: "translate(-217.509 -148.428)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M376.5,249.136c0,.087-3.421.161-7.641.161s-7.641-.074-7.641-.161,3.417-.166,7.641-.166S376.5,249.044,376.5,249.136Z",
    transform: "translate(-217.509 -151.55)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2926",
    "data-name": "Path 2926",
    d: "M376.5,254.681c0,.087-3.421.161-7.641.161s-7.641-.074-7.641-.161,3.417-.161,7.641-.161S376.5,254.59,376.5,254.681Z",
    transform: "translate(-217.509 -154.678)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2927",
    "data-name": "Path 2927",
    d: "M376.5,260.221c0,.092-3.421.166-7.641.166s-7.641-.074-7.641-.166,3.417-.161,7.641-.161S376.5,260.134,376.5,260.221Z",
    transform: "translate(-217.509 -157.801)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2928",
    "data-name": "Path 2928",
    d: "M376.5,265.786c0,.087-3.421.161-7.641.161s-7.641-.074-7.641-.161,3.417-.166,7.641-.166S376.5,265.685,376.5,265.786Z",
    transform: "translate(-217.509 -160.934)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2929",
    "data-name": "Path 2929",
    d: "M376.5,271.311c0,.092-3.421.161-7.641.161s-7.641-.07-7.641-.161,3.417-.161,7.641-.161S376.5,271.22,376.5,271.311Z",
    transform: "translate(-217.509 -164.051)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2930",
    "data-name": "Path 2930",
    d: "M431.044,232.3c0,.087-3.365.637-7.545,1.231s-7.576.995-7.589.9,3.365-.637,7.545-1.226S431.031,232.217,431.044,232.3Z",
    transform: "translate(-248.333 -142.151)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2931",
    "data-name": "Path 2931",
    d: "M431.744,235.773c0,.087-3.369.637-7.545,1.226s-7.58.995-7.589.908,3.365-.637,7.541-1.226S431.731,235.682,431.744,235.773Z",
    transform: "translate(-248.727 -144.105)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2932",
    "data-name": "Path 2932",
    d: "M432.374,238.983c0,.087-3.365.637-7.545,1.226s-7.576,1-7.589.908,3.365-.637,7.545-1.226S432.361,238.892,432.374,238.983Z",
    transform: "translate(-249.082 -145.915)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2933",
    "data-name": "Path 2933",
    d: "M426.528,137.541c0,.092-3.866.161-8.632.161s-8.636-.07-8.636-.161,3.866-.161,8.636-.161S426.528,137.45,426.528,137.541Z",
    transform: "translate(-244.585 -88.657)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2934",
    "data-name": "Path 2934",
    d: "M426.528,140.836c0,.087-3.866.161-8.632.161s-8.636-.074-8.636-.161,3.866-.166,8.636-.166S426.528,140.744,426.528,140.836Z",
    transform: "translate(-244.585 -90.512)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2935",
    "data-name": "Path 2935",
    d: "M426.528,144.131c0,.092-3.866.161-8.632.161s-8.636-.07-8.636-.161,3.866-.161,8.636-.161S426.528,144.044,426.528,144.131Z",
    transform: "translate(-244.585 -92.372)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2936",
    "data-name": "Path 2936",
    d: "M426.528,147.431c0,.087-3.866.161-8.632.161s-8.636-.074-8.636-.161,3.866-.161,8.636-.161S426.528,147.34,426.528,147.431Z",
    transform: "translate(-244.585 -94.231)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2937",
    "data-name": "Path 2937",
    d: "M426.528,150.721c0,.092-3.866.166-8.632.166s-8.636-.074-8.636-.166,3.866-.161,8.636-.161S426.528,150.634,426.528,150.721Z",
    transform: "translate(-244.585 -96.086)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2938",
    "data-name": "Path 2938",
    d: "M426.528,154.021c0,.092-3.866.161-8.632.161s-8.636-.07-8.636-.161,3.866-.161,8.636-.161S426.528,153.921,426.528,154.021Z",
    transform: "translate(-244.585 -97.946)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    d: "M426.528,157.316c0,.087-3.866.161-8.632.161s-8.636-.074-8.636-.161,3.866-.166,8.636-.166S426.528,157.224,426.528,157.316Z",
    transform: "translate(-244.585 -99.8)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    d: "M426.528,167.1c0,.087-3.866.161-8.632.161s-8.636-.074-8.636-.161,3.866-.161,8.636-.161S426.528,167.01,426.528,167.1Z",
    transform: "translate(-244.585 -105.318)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2941",
    "data-name": "Path 2941",
    d: "M426.808,170.581c0,.087-3.866.161-8.632.161s-8.636-.074-8.636-.161,3.866-.161,8.636-.161S426.808,170.49,426.808,170.581Z",
    transform: "translate(-244.743 -107.279)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2942",
    "data-name": "Path 2942",
    d: "M427.088,174.061c0,.092-3.866.161-8.632.161s-8.636-.07-8.636-.161,3.866-.161,8.636-.161S427.088,173.974,427.088,174.061Z",
    transform: "translate(-244.9 -109.24)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2943",
    "data-name": "Path 2943",
    d: "M427.368,177.541c0,.092-3.866.161-8.636.161s-8.632-.07-8.632-.161,3.866-.161,8.632-.161S427.368,177.454,427.368,177.541Z",
    transform: "translate(-245.058 -111.202)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2944",
    "data-name": "Path 2944",
    d: "M427.7,181.021c0,.092-3.866.166-8.636.166s-8.632-.074-8.632-.166,3.862-.161,8.632-.161S427.7,180.921,427.7,181.021Z",
    transform: "translate(-245.244 -113.163)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2945",
    "data-name": "Path 2945",
    d: "M427.924,184.506c0,.087-3.862.161-8.632.161s-8.632-.074-8.632-.161,3.862-.166,8.632-.166S427.924,184.414,427.924,184.506Z",
    transform: "translate(-245.374 -115.124)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_992",
    "data-name": "Rectangle 992",
    width: 54.575,
    height: 79.105,
    transform: "translate(2.743 20.955)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_993",
    "data-name": "Rectangle 993",
    width: 54.575,
    height: 79.105,
    transform: "translate(0.011 20.955)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_994",
    "data-name": "Rectangle 994",
    width: 41.017,
    height: 61.972,
    transform: "translate(6.792 29.521)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2946",
    "data-name": "Path 2946",
    d: "M88.336,155.138v-4.573c0-2.967,0-7.3-.039-12.765,0-10.91-.039-26.4-.065-44.626l.135.14H47.345l.148-.148c0,23.382-.022,44.949-.031,61.968l-.118-.118,29.849.061,8.248.031H85.5l-8.222.031-29.924.061h-.122v-.118c0-17.019,0-38.59-.026-61.968V93H88.523v.135c-.026,18.263-.048,33.768-.065,44.717,0,5.451-.026,9.771-.035,12.734v4.242A.49.49,0,0,1,88.336,155.138Z",
    transform: "translate(-40.531 -63.645)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2947",
    "data-name": "Path 2947",
    d: "M147.742,73.75a9.558,9.558,0,0,1-.973,1.418c-.633.847-1.532,2-2.562,3.247s-1.986,2.352-2.7,3.138a9.536,9.536,0,0,1-1.2,1.226,9.993,9.993,0,0,1,1.043-1.362c.729-.873,1.632-1.981,2.618-3.19l2.618-3.19a10.128,10.128,0,0,1,1.152-1.287Z",
    transform: "translate(-93.003 -52.795)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2948",
    "data-name": "Path 2948",
    d: "M141.93,234.93a50.688,50.688,0,0,0,7.152,8.946",
    transform: "translate(-93.916 -143.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2949",
    "data-name": "Path 2949",
    d: "M149.083,243.876a8.013,8.013,0,0,1-1.248-1.135,39.778,39.778,0,0,1-5.071-6.345,8.035,8.035,0,0,1-.834-1.466,11.849,11.849,0,0,1,1.008,1.348c.6.847,1.444,2,2.431,3.238s1.929,2.309,2.618,3.085A11.468,11.468,0,0,1,149.083,243.876Z",
    transform: "translate(-93.916 -143.637)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2950",
    "data-name": "Path 2950",
    d: "M31.91,243.49l7.148-8.82",
    transform: "translate(-31.908 -143.491)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2951",
    "data-name": "Path 2951",
    d: "M39.056,234.669a53.2,53.2,0,0,1-3.461,4.5,55.788,55.788,0,0,1-3.688,4.316,54.031,54.031,0,0,1,3.461-4.5A54.793,54.793,0,0,1,39.056,234.669Z",
    transform: "translate(-31.905 -143.489)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2952",
    "data-name": "Path 2952",
    d: "M31.927,73.749a54.072,54.072,0,0,1,3.491,4.15,45.64,45.64,0,0,1,3.238,4.329,52.316,52.316,0,0,1-3.491-4.146A44.71,44.71,0,0,1,31.927,73.749Z",
    transform: "translate(-31.916 -52.794)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_995",
    "data-name": "Rectangle 995",
    width: 13.733,
    height: 38.992,
    transform: "translate(21.294 42.107)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2953",
    "data-name": "Path 2953",
    d: "M223.6,366.77s-2.492-17.128-2.287-27.091,0-21.178,0-21.178h1.152s-.781,19.782.065,31.713,3.055,16.557,3.055,16.557h-1.994",
    transform: "translate(-138.651 -190.738)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2954",
    "data-name": "Path 2954",
    d: "M228.736,272a3.024,3.024,0,0,0-1.047-1.532,2.959,2.959,0,0,0-2.492,0c-3.491,1.226-6.546,7.694-7.947,11.1l4.6,15.514C230.167,289.387,231.607,279.271,228.736,272Z",
    transform: "translate(-136.367 -163.51)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2955",
    "data-name": "Path 2955",
    d: "M233.361,272.27a1.213,1.213,0,0,1-.065.2l-.227.567c-.2.489-.484,1.2-.825,2.077-.676,1.746-1.54,4.229-2.313,6.982a73.251,73.251,0,0,0-1.628,7.192c-.161.93-.288,1.685-.367,2.208-.039.24-.07.436-.1.6a.829.829,0,0,1-.048.209.99.99,0,0,1,0-.214c0-.157.039-.358.065-.607.052-.524.157-1.283.305-2.217a65.921,65.921,0,0,1,1.575-7.222,65.114,65.114,0,0,1,2.374-6.982c.353-.873.655-1.58.873-2.06l.262-.55A.967.967,0,0,1,233.361,272.27Z",
    transform: "translate(-142.305 -164.682)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2956",
    "data-name": "Path 2956",
    d: "M213.922,311.163a14.046,14.046,0,0,1-7.1-11.783,25.2,25.2,0,0,1,2.09-10.037,1.309,1.309,0,0,1,.484-.729,1.244,1.244,0,0,1,1.178.183c3.138,1.785,5.036,5.193,6.048,8.658a17.5,17.5,0,0,1,.711,7.118,11.857,11.857,0,0,1-3.417,6.624",
    transform: "translate(-130.482 -173.853)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2957",
    "data-name": "Path 2957",
    d: "M219.193,314.37a.7.7,0,0,1,0-.21v-.593c0-.519-.026-1.266-.065-2.182a60.022,60.022,0,0,0-.8-7.17c-.48-2.78-1.06-5.267-1.488-7.065-.209-.873-.384-1.6-.511-2.134l-.131-.58a.645.645,0,0,1-.035-.205,1.012,1.012,0,0,1,.07.2l.166.572c.144.5.34,1.222.572,2.117.463,1.794,1.065,4.281,1.545,7.07a52.492,52.492,0,0,1,.746,7.192c.026.93.026,1.676,0,2.182a4.678,4.678,0,0,1-.022.593A1.1,1.1,0,0,1,219.193,314.37Z",
    transform: "translate(-135.752 -177.059)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2958",
    "data-name": "Path 2958",
    d: "M234.27,399.96c4.25.934,7.746,3.928,11.844,5.389,2.714.964,5.778,1.309,7.942,3.2a6.736,6.736,0,0,0-2.946-2.933,52.8,52.8,0,0,0-10.735-5.123c-1.929-.668-4.019-1.222-5.987-.672",
    transform: "translate(-145.959 -236.444)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2959",
    "data-name": "Path 2959",
    d: "M199.246,401.857c-5.32-.087-10.91-4.617-16.216-4.888,5.542-1.789,13.476-.327,16.216,4.888",
    transform: "translate(-117.08 -234.553)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2960",
    "data-name": "Path 2960",
    d: "M224.977,371.485a17.332,17.332,0,0,1,8.505-.58,51.224,51.224,0,0,1,8.291,2.261c-.275-1.846-1.767-3.234-3.173-4.464a21.983,21.983,0,0,0-3.334-2.562A7.419,7.419,0,0,0,231.262,365a6.341,6.341,0,0,0-4.412,2.226,7.327,7.327,0,0,0-1.89,4.25",
    transform: "translate(-140.712 -216.945)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2961",
    "data-name": "Path 2961",
    d: "M183.376,363.125c-3.352-2.858-8.422-2.579-12.826-2.479a104.235,104.235,0,0,1,19.886,12.394C190.615,369.932,187.6,366.738,183.376,363.125Z",
    transform: "translate(-110.046 -214.459)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2962",
    "data-name": "Path 2962",
    d: "M228.392,339.6a37.622,37.622,0,0,1,5.149-2.994c1.746-.8,3.408-2.073,5.11-3a55.826,55.826,0,0,0,6.149-4.338,15.951,15.951,0,0,1,6.729-3.212,13.2,13.2,0,0,0-6.109.353,39.9,39.9,0,0,0-5.765,2.243,28.3,28.3,0,0,0-7.419,4.294c-2.147,1.911-4.067,3.8-3.84,6.651",
    transform: "translate(-142.639 -194.881)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2963",
    "data-name": "Path 2963",
    d: "M240.342,403.935a.871.871,0,0,1-.17-.074l-.463-.24c-.4-.214-.978-.528-1.7-.895-.358-.188-.755-.384-1.187-.589s-.873-.436-1.379-.633a20.71,20.71,0,0,0-3.277-1.143,7.044,7.044,0,0,0-3.413-.083,9.708,9.708,0,0,0-1.444.436,7.137,7.137,0,0,0-1.17.6,7.476,7.476,0,0,0-1.466,1.213c-.31.327-.458.532-.471.519a.6.6,0,0,1,.1-.153,5.129,5.129,0,0,1,.319-.436,6.982,6.982,0,0,1,1.449-1.274,7.32,7.32,0,0,1,1.183-.633,9.631,9.631,0,0,1,1.466-.436,7.108,7.108,0,0,1,3.491.07,19.641,19.641,0,0,1,3.3,1.165c.493.218.956.436,1.379.655s.825.415,1.183.611c.716.38,1.283.716,1.671.947l.436.271C240.294,403.887,240.347,403.926,240.342,403.935Z",
    transform: "translate(-140.284 -236.631)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2964",
    "data-name": "Path 2964",
    d: "M211.1,403.07a1.149,1.149,0,0,1,.332.1,7.51,7.51,0,0,1,.873.375,10.5,10.5,0,0,1,4.425,4.272,7.018,7.018,0,0,1,.41.851,1.113,1.113,0,0,1,.109.327c-.031,0-.227-.436-.637-1.113a11.887,11.887,0,0,0-4.39-4.22C211.545,403.28,211.087,403.1,211.1,403.07Z",
    transform: "translate(-132.9 -238.402)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2965",
    "data-name": "Path 2965",
    d: "M184.13,365.79a1.044,1.044,0,0,1,.227.065l.637.227,1.008.371c.393.148.816.362,1.309.576a30.611,30.611,0,0,1,6.926,4.412,33.386,33.386,0,0,1,3.229,3.181,35.548,35.548,0,0,1,2.291,2.9c.611.873,1.069,1.58,1.383,2.073.153.236.271.436.367.572a1.131,1.131,0,0,1,.118.205.965.965,0,0,1-.148-.183c-.1-.122-.231-.31-.4-.55-.332-.484-.812-1.187-1.431-2.038s-1.4-1.824-2.313-2.867a36.393,36.393,0,0,0-3.221-3.151,32.37,32.37,0,0,0-6.86-4.434c-.48-.223-.9-.436-1.309-.6l-.991-.4-.624-.262A1.192,1.192,0,0,1,184.13,365.79Z",
    transform: "translate(-117.7 -217.391)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2966",
    "data-name": "Path 2966",
    d: "M232.029,372.478a1.871,1.871,0,0,1-.436-.057l-.489-.087c-.192-.039-.41-.039-.655-.065a6.629,6.629,0,0,0-5.307,1.955,7.534,7.534,0,0,0-1.069,1.309,12.107,12.107,0,0,0-.733,1.392,1.794,1.794,0,0,1,.109-.415,6.143,6.143,0,0,1,.511-1.052,7.037,7.037,0,0,1,1.06-1.375,6.463,6.463,0,0,1,5.455-1.964,6.006,6.006,0,0,1,.659.092l.489.122A1.744,1.744,0,0,1,232.029,372.478Z",
    transform: "translate(-139.799 -220.932)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2967",
    "data-name": "Path 2967",
    d: "M237.036,335a1.073,1.073,0,0,1-.2.122l-.593.323c-.515.279-1.257.689-2.182,1.218s-1.955,1.2-3.081,2.007a25.9,25.9,0,0,0-3.443,2.885,8.552,8.552,0,0,0-1.405,1.82c-.349.672-.685,1.309-.991,1.938a33.835,33.835,0,0,0-1.475,3.365,19.911,19.911,0,0,0-.72,2.37c-.135.572-.188.873-.205.873a1.171,1.171,0,0,1,.022-.236,4.278,4.278,0,0,1,.109-.668,17.522,17.522,0,0,1,.668-2.4,32.3,32.3,0,0,1,1.444-3.4c.305-.624.633-1.274.982-1.942A8.842,8.842,0,0,1,227.4,341.4a24.921,24.921,0,0,1,3.491-2.893c1.135-.8,2.2-1.453,3.116-1.977s1.667-.912,2.182-1.17l.607-.292A.873.873,0,0,1,237.036,335Z",
    transform: "translate(-139.461 -200.037)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2968",
    "data-name": "Path 2968",
    d: "M216.732,357.628a1.96,1.96,0,0,1-.1-.436c-.065-.327-.14-.738-.236-1.226a34.038,34.038,0,0,0-1-3.993,35.054,35.054,0,0,0-1.519-3.827c-.209-.436-.384-.838-.519-1.139a1.99,1.99,0,0,1-.17-.436,2.288,2.288,0,0,1,.236.393c.14.262.34.641.572,1.113a26.318,26.318,0,0,1,2.54,7.855c.083.524.14.947.17,1.244A2.117,2.117,0,0,1,216.732,357.628Z",
    transform: "translate(-134.073 -206.558)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2969",
    "data-name": "Path 2969",
    d: "M201.587,324.354a14.462,14.462,0,0,0-1.746-5.743,18.961,18.961,0,0,0-12.852-9.6l11.9,17.735,1.536,3.164A8.962,8.962,0,0,0,201.587,324.354Z",
    transform: "translate(-119.312 -185.389)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_996",
    "data-name": "Rectangle 996",
    width: 27.667,
    height: 4.905,
    transform: "translate(71.675 173.915)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2970",
    "data-name": "Path 2970",
    d: "M200.88,433.27l2.357,15.213H221.6l2.81-15.213Z",
    transform: "translate(-127.141 -255.423)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2971",
    "data-name": "Path 2971",
    d: "M223.507,435.386c0,.052-6.24.1-13.938.1s-13.938-.044-13.938-.1,6.24-.1,13.938-.1S223.507,435.334,223.507,435.386Z",
    transform: "translate(-124.182 -256.561)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-50",
    transform: "translate(9452.5 1945.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2972",
    "data-name": "Path 2972",
    d: "M16.76,468.213c0-.061,43.993-.113,98.25-.113s98.258.052,98.258.113-43.984.113-98.258.113S16.76,468.279,16.76,468.213Z",
    transform: "translate(-16.76 -468.1)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-50",
    transform: "translate(9532.456 1812.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2973",
    "data-name": "Path 2973",
    d: "M244.327,175.3c-.065,0-.083-2.4-.044-5.359s.122-5.355.183-5.355.083,2.4.044,5.359S244.388,175.3,244.327,175.3Z",
    transform: "translate(-224.938 -164.59)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2974",
    "data-name": "Path 2974",
    d: "M204.239,188.253a59.386,59.386,0,0,1-4.259-6.083,30.231,30.231,0,0,1,2.221,2.976A29.6,29.6,0,0,1,204.239,188.253Z",
    transform: "translate(-199.98 -174.498)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2975",
    "data-name": "Path 2975",
    d: "M272.345,194.42a7.242,7.242,0,0,1-.916.873c-.585.515-1.414,1.209-2.348,1.946s-1.8,1.388-2.431,1.842a6.5,6.5,0,0,1-1.06.69,7.941,7.941,0,0,1,.964-.816l2.387-1.89,2.383-1.894A7.05,7.05,0,0,1,272.345,194.42Z",
    transform: "translate(-236.958 -181.402)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-50",
    transform: "translate(9526.128 1816.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2976",
    "data-name": "Path 2976",
    d: "M223.61,172.155l.179.362a.122.122,0,0,0,.1.07l.4.061a.127.127,0,0,1,.074.218l-.292.284a.127.127,0,0,0-.035.113l.065.4a.127.127,0,0,1-.188.135l-.358-.188a.148.148,0,0,0-.122,0l-.358.188a.127.127,0,0,1-.188-.135l.07-.4a.14.14,0,0,0-.039-.113l-.288-.284a.127.127,0,0,1,.07-.218l.4-.061a.118.118,0,0,0,.1-.07l.179-.362a.131.131,0,0,1,.236,0Z",
    transform: "translate(-206.393 -172.081)",
    fill: "#db81d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2977",
    "data-name": "Path 2977",
    d: "M286.432,209.59l.179.362a.144.144,0,0,0,.1.074l.4.057a.131.131,0,0,1,.07.223l-.288.284a.131.131,0,0,0-.039.113l.07.4a.131.131,0,0,1-.188.14l-.358-.192a.148.148,0,0,0-.122,0l-.358.192a.131.131,0,0,1-.188-.14l.065-.4a.118.118,0,0,0-.035-.113l-.292-.284a.131.131,0,0,1,.074-.223l.4-.057a.139.139,0,0,0,.1-.074l.179-.362a.131.131,0,0,1,.231,0Z",
    transform: "translate(-241.801 -193.182)",
    fill: "#db81d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2978",
    "data-name": "Path 2978",
    d: "M264.928,175.379l.327.663a.244.244,0,0,0,.179.131l.729.1a.236.236,0,0,1,.131.4l-.528.515a.236.236,0,0,0-.065.209l.122.729a.236.236,0,0,1-.34.249l-.655-.345a.24.24,0,0,0-.218,0l-.655.345a.236.236,0,0,1-.345-.249l.127-.729a.24.24,0,0,0-.07-.209l-.528-.515a.236.236,0,0,1,.131-.4l.733-.1a.236.236,0,0,0,.175-.131l.327-.663a.236.236,0,0,1,.423,0Z",
    transform: "translate(-229.208 -173.866)",
    fill: "#db81d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2979",
    "data-name": "Path 2979",
    d: "M187.338,214.684l.327.659a.244.244,0,0,0,.175.131l.733.1a.236.236,0,0,1,.131.4l-.528.511a.227.227,0,0,0-.07.205l.127.729a.236.236,0,0,1-.345.249l-.65-.345a.249.249,0,0,0-.223,0l-.655.345a.236.236,0,0,1-.34-.249l.127-.729a.227.227,0,0,0-.07-.205l-.528-.519a.236.236,0,0,1,.131-.4l.729-.1a.244.244,0,0,0,.179-.131l.327-.659a.236.236,0,0,1,.423.009Z",
    transform: "translate(-185.478 -196.015)",
    fill: "#db81d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2980",
    "data-name": "Path 2980",
    d: "M274.348,240.677l.327.659a.244.244,0,0,0,.179.131l.729.1a.236.236,0,0,1,.131.4l-.528.515a.227.227,0,0,0-.07.205l.127.729a.236.236,0,0,1-.345.249l-.65-.345a.249.249,0,0,0-.223,0l-.65.345a.236.236,0,0,1-.345-.249l.127-.729a.227.227,0,0,0-.07-.205l-.528-.519a.236.236,0,0,1,.131-.4l.729-.1a.244.244,0,0,0,.179-.131l.327-.659a.236.236,0,0,1,.423,0Z",
    transform: "translate(-234.517 -210.666)",
    fill: "#db81d2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-50",
    transform: "translate(9570.025 1789.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2981",
    "data-name": "Path 2981",
    d: "M302.931,115.478l7.2-5.568.694,9.042,9.627-.642-6.376,8.331L320,132.476l-10.05,1.641,2.278,11.076-7.362-8.126-8.924,5.206.1-9.073-9.6-2.736,7.358-5.472-5.424-7.41,7.89,1.261.2-8.872Z",
    transform: "translate(-286.279 -109.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2982",
    "data-name": "Path 2982",
    d: "M286.188,130.351l-.118.087.14.039,9.6,2.741-.052-.074c-.035,2.885-.07,5.944-.1,9.073v.14l.122-.07,8.924-5.206h-.1l2.007,2.217,5.355,5.913.2.218-.057-.288q-1.17-5.673-2.282-11.08l-.061.092,10.037-1.641h.144l-.1-.1-5.926-5.83v.092l6.371-8.335.083-.109h-.135l-9.627.65.052.048c-.275-3.561-.511-6.546-.7-9.042v-.07l-.057.044L304.556,114l-1.375,1.074-.467.371.467-.349,1.379-1.056,5.389-4.15-.061-.026c.183,2.487.41,5.481.676,9.046v.052h.048l9.631-.633-.057-.1c-1.981,2.588-4.115,5.376-6.38,8.326l-.039.052.044.039q2.85,2.815,5.922,5.839l.039-.122L309.736,134h-.079v.079q1.1,5.389,2.274,11.08l.135-.07-5.341-5.917c-.689-.755-1.375-1.514-2.007-2.217l-.044-.048-.057.035-8.924,5.211.118.07c.035-3.129.065-6.192.1-9.073v-.061h-.057l-9.6-2.732.026.131,7.353-5.481.052-.039-.039-.057-5.429-7.419-.057.1,7.89,1.248h.057v-.057c.074-3.443.135-6.437.188-8.872l-.061.026,4.8,4.076,1.252,1.052c.279.236.436.349.436.349l-.436-.371-1.244-1.069-4.8-4.093-.057-.048v.079c-.057,2.431-.131,5.429-.214,8.868l.061-.048-7.89-1.266H288l.087.113,5.416,7.419v-.1",
    transform: "translate(-286.07 -109.81)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2983",
    "data-name": "Path 2983",
    d: "M322.3,135.536l.668,6.2a1.008,1.008,0,0,0,.986.9h0a1.008,1.008,0,0,0,1.026-.943l.436-6.288a.8.8,0,0,0-.838-.847l-1.519.092a.79.79,0,0,0-.759.886Z",
    transform: "translate(-306.487 -123.758)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2984",
    "data-name": "Path 2984",
    d: "M325.693,157.2a1.519,1.519,0,1,1-.133-1.158A1.519,1.519,0,0,1,325.693,157.2Z",
    transform: "translate(-306.723 -135.425)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-50",
    transform: "translate(9538.217 1829.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2985",
    "data-name": "Path 2985",
    d: "M438.134,283.013c-1.994-2.282-5.372-2.762-7.759-4.63-3.216-2.518-4.032-7.022-4.146-11.111s.2-8.374-1.575-12.058A11.757,11.757,0,0,0,413.16,248.8l-5.381,5.237a13.5,13.5,0,0,1,3.282,10.561c-.58,3.618-3.709,10.508-4.006,14.161-.642,7.951,2.483,13.733,9.749,17.019a10.53,10.53,0,0,0,5.725,1.082,5.509,5.509,0,0,0,4.491-3.378,9.4,9.4,0,0,0,10.085-.873C439.819,290.3,440.491,285.706,438.134,283.013Z",
    transform: "translate(-322.403 -225.499)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2986",
    "data-name": "Path 2986",
    d: "M229.479,227.584a42.046,42.046,0,0,1,2.906-4.971c.58-.476,1.427-.371,1.375.436A15.761,15.761,0,0,1,232.7,226.1s1.746-5.123,3.116-6.131,1.536-.209,1.536.532c0,0,1-3.317,2.326-2.719s.262,2.662.262,2.662,1.427-2.588,2.483-1.663-1.794,5.839-1.794,5.839,1.056-.476.738,1.427-.685,4.6-1.584,6.184-2.959,5.394-4.547,7.667-2.108,22.4-2.108,22.4-6.873,4.072-10.2,3.544l-1.309-.214,4.281-24.364a9.091,9.091,0,0,1-.724-4.652C225.377,233.663,229.479,227.584,229.479,227.584Z",
    transform: "translate(-217.937 -208)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2987",
    "data-name": "Path 2987",
    d: "M249.635,238.27a7.94,7.94,0,0,1-1.187.1c-.738.052-1.746.144-2.854.319s-2.1.4-2.815.567a7.291,7.291,0,0,1-1.17.253,5.071,5.071,0,0,1,1.13-.406,22.073,22.073,0,0,1,2.819-.642,21.581,21.581,0,0,1,2.88-.253,5.067,5.067,0,0,1,1.2.057Z",
    transform: "translate(-229.203 -219.546)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2988",
    "data-name": "Path 2988",
    d: "M253.469,223.47a4.8,4.8,0,0,1-.367,1.078c-.262.65-.659,1.536-1.148,2.492s-.969,1.794-1.344,2.387a5.062,5.062,0,0,1-.65.93,5.976,5.976,0,0,1,.515-1.008c.336-.615.794-1.462,1.279-2.413s.9-1.82,1.2-2.453a6.849,6.849,0,0,1,.515-1.012Z",
    transform: "translate(-233.909 -211.244)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2989",
    "data-name": "Path 2989",
    d: "M259.1,222.83a6.385,6.385,0,0,1-.55.995l-1.4,2.352-1.379,2.37a6.276,6.276,0,0,1-.6.964,5.425,5.425,0,0,1,.463-1.043c.319-.628.777-1.479,1.309-2.4s1.065-1.746,1.462-2.326A5.046,5.046,0,0,1,259.1,222.83Z",
    transform: "translate(-236.846 -210.883)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2990",
    "data-name": "Path 2990",
    d: "M243.22,245.255a.886.886,0,0,1,.022-.161,3.97,3.97,0,0,1,.127-.436,6.813,6.813,0,0,1,.751-1.549,7.183,7.183,0,0,1,1.746-1.85,19.454,19.454,0,0,0,2.479-1.824c1.567-1.558,1.706-3.749,2.693-4.888A3.1,3.1,0,0,1,252.4,233.5a1.663,1.663,0,0,1,.463-.092.5.5,0,0,1,.161,0,3.93,3.93,0,0,0-.594.161,3.19,3.19,0,0,0-1.27,1.06,8.466,8.466,0,0,0-1.056,2.26,7.419,7.419,0,0,1-1.6,2.688A17.976,17.976,0,0,1,246,241.415a7.188,7.188,0,0,0-1.746,1.772,9.862,9.862,0,0,0-1.03,2.069Z",
    transform: "translate(-230.111 -216.844)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2991",
    "data-name": "Path 2991",
    d: "M375.432,209.269a21.165,21.165,0,0,0-13.149-12.756c-3.53-1.187-5.237-.916-8.008-1.043a11.806,11.806,0,0,0-7.737,2.182,19.759,19.759,0,0,0-6.406,7.419,55.358,55.358,0,0,0-3.539,9.518,18.489,18.489,0,0,0,.122,10.037l7.742,4.032c4.477,1.6,9.02,3.208,13.759,3.578s9.78-.633,13.371-3.749C376.562,224.163,377.871,215.409,375.432,209.269Z",
    transform: "translate(-282.379 -195.454)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M-9325.479-1785.511l1.067-.81c.975-2.859,1.471-4.212,1.471-4.212s-7.074-3.032-6.2-12.2c.436-4.552,2.517-11.665,4.4-17.426,1.7-5.189,8.387-10.86,14.816-8.842l2.958.581,9.544,7.825a3.194,3.194,0,0,1,1.955,3.854l-4.894,12.433a1.23,1.23,0,0,1,.784-.325c1.8.18,4.875,1.126,3.765,5.517-1.218,4.83-6.033,3.868-7.857,3.214l-5.648,14.352-.332.274a19.638,19.638,0,0,1-6.986,1.369C-9321.438-1779.9-9325.077-1782.046-9325.479-1785.511Z",
    transform: "translate(9383.198 1832.032)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2993",
    "data-name": "Path 2993",
    d: "M347.649,239a1.165,1.165,0,0,0,.794,1.418,1.113,1.113,0,0,0,1.427-.716,1.165,1.165,0,0,0-.79-1.418,1.117,1.117,0,0,0-1.431.716Z",
    transform: "translate(-288.945 -219.556)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2994",
    "data-name": "Path 2994",
    d: "M349.509,229.789c.1.183,1.117-.231,2.33.087s1.946,1.156,2.116,1.043c.083-.052,0-.353-.305-.737a3.2,3.2,0,0,0-1.645-1.012,3.1,3.1,0,0,0-1.907.109C349.653,229.475,349.457,229.7,349.509,229.789Z",
    transform: "translate(-290.011 -214.399)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2995",
    "data-name": "Path 2995",
    d: "M356.5,244.848a8.569,8.569,0,0,0-1.876-.873c-.3-.113-.58-.253-.576-.476a1.588,1.588,0,0,1,.436-.873c.484-.676.991-1.383,1.527-2.125a42.2,42.2,0,0,0,3.657-5.634,42.183,42.183,0,0,0-4.1,5.328c-.524.751-1.021,1.462-1.492,2.147a1.829,1.829,0,0,0-.476,1.174.8.8,0,0,0,.388.585,2.073,2.073,0,0,0,.511.209A7.827,7.827,0,0,0,356.5,244.848Z",
    transform: "translate(-292.321 -217.667)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2996",
    "data-name": "Path 2996",
    d: "M350.311,290.4a23.129,23.129,0,0,0,12.59-.092s-4.717,5.28-13.3,2.182Z",
    transform: "translate(-290.067 -248.916)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2997",
    "data-name": "Path 2997",
    d: "M353.49,220.62c.127.349,1.108.393,2.182.764s1.885.873,2.182.685c.14-.1.1-.436-.2-.816a3.4,3.4,0,0,0-1.6-1.078,3.338,3.338,0,0,0-1.916-.092C353.661,220.222,353.438,220.454,353.49,220.62Z",
    transform: "translate(-292.255 -209.28)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2998",
    "data-name": "Path 2998",
    d: "M374.33,246.439a1.156,1.156,0,0,1-1.41.8,1.108,1.108,0,0,1-.851-1.348,1.165,1.165,0,0,1,1.414-.8,1.108,1.108,0,0,1,.847,1.348Z",
    transform: "translate(-302.713 -223.408)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2999",
    "data-name": "Path 2999",
    d: "M381.163,238.913c-.183.1-.842-.777-2.042-1.13s-2.26,0-2.348-.205c-.044-.087.175-.305.641-.471a3.19,3.19,0,0,1,1.933,0,3.112,3.112,0,0,1,1.571,1.082C381.2,238.568,381.233,238.869,381.163,238.913Z",
    transform: "translate(-305.379 -218.845)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3000",
    "data-name": "Path 3000",
    d: "M382.163,229.443c-.319.2-1.161-.358-2.269-.707s-2.112-.436-2.243-.781c-.052-.166.175-.4.668-.532a3.8,3.8,0,0,1,3.635,1.2C382.254,229.02,382.3,229.343,382.163,229.443Z",
    transform: "translate(-305.872 -213.425)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3002",
    "data-name": "Path 3002",
    d: "M402,268.063c.031,0,.087.1.244.227a1.091,1.091,0,0,0,.777.214c.694-.074,1.479-.947,1.785-2.021a3.535,3.535,0,0,0,.083-1.571,1.252,1.252,0,0,0-.585-1,.554.554,0,0,0-.69.131c-.122.148-.113.279-.148.279s-.1-.131,0-.367a.663.663,0,0,1,.327-.319.838.838,0,0,1,.62,0,1.519,1.519,0,0,1,.873,1.209,3.626,3.626,0,0,1-.057,1.746c-.345,1.2-1.248,2.182-2.182,2.208a1.157,1.157,0,0,1-.916-.4A.444.444,0,0,1,402,268.063Z",
    transform: "translate(-319.598 -233.847)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3003",
    "data-name": "Path 3003",
    d: "M387.533,225.416l-1.99,1.074c-4.49-8.243-12.188-27.75-11.783-26.62a19.744,19.744,0,0,1,9.548,1.938c4.543,2.348,12.891,7.654,10.945,13.279S387.533,225.416,387.533,225.416Z",
    transform: "translate(-303.675 -197.916)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3004",
    "data-name": "Path 3004",
    d: "M398.169,224.8a1.609,1.609,0,0,0,0-.358,6.657,6.657,0,0,0-.109-1.026,8.773,8.773,0,0,0-1.567-3.447,16.618,16.618,0,0,0-4.106-3.871c-1.746-1.235-3.766-2.413-5.616-4a29.878,29.878,0,0,1-4.713-4.97,31.222,31.222,0,0,1-2.928-4.761,32.845,32.845,0,0,1-1.462-3.469l-.332-.969a1.513,1.513,0,0,0-.135-.336,1.827,1.827,0,0,0,.074.353c.061.227.144.563.275.991a28,28,0,0,0,1.383,3.522,29.83,29.83,0,0,0,2.893,4.835,29.4,29.4,0,0,0,4.744,5.04,66.27,66.27,0,0,0,5.673,4,17.046,17.046,0,0,1,4.12,3.753,9.064,9.064,0,0,1,1.623,3.347C398.151,224.3,398.134,224.8,398.169,224.8Z",
    transform: "translate(-305.622 -196.658)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3005",
    "data-name": "Path 3005",
    d: "M396.3,227.706a3.309,3.309,0,0,0,.179-1.362,6.323,6.323,0,0,0-1.309-3.491,13.968,13.968,0,0,0-4.3-3.491,30.267,30.267,0,0,1-5.49-3.884,27.2,27.2,0,0,1-4.364-5.093,27.775,27.775,0,0,1-2.566-4.861A30.092,30.092,0,0,1,377.28,202l-.236-.982a1.223,1.223,0,0,0-.1-.34,1.614,1.614,0,0,0,.044.349c.044.266.1.593.179,1a25.109,25.109,0,0,0,1.078,3.574,26.712,26.712,0,0,0,6.934,10.107,29.644,29.644,0,0,0,5.555,3.9A14.137,14.137,0,0,1,395,222.988a6.376,6.376,0,0,1,1.388,3.352A7.629,7.629,0,0,1,396.3,227.706Z",
    transform: "translate(-305.476 -198.4)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3007",
    "data-name": "Path 3007",
    d: "M362.476,265.117a3.055,3.055,0,0,0,1.309-.17,1.977,1.977,0,0,0,1.017-.93,2.081,2.081,0,0,0,.083-1.663c-.113-.275-.275-.559-.493-.585a2.748,2.748,0,0,0-.807.144l-1.453.362a6.321,6.321,0,0,1-1.362.262,6.108,6.108,0,0,1,1.309-.471l1.44-.436a2.535,2.535,0,0,1,.925-.17.755.755,0,0,1,.476.31,1.892,1.892,0,0,1,.249.463,2.3,2.3,0,0,1-.118,1.9,2.121,2.121,0,0,1-1.187,1A1.6,1.6,0,0,1,362.476,265.117Z",
    transform: "translate(-296.362 -232.655)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3008",
    "data-name": "Path 3008",
    d: "M419.989,241.93a3.889,3.889,0,0,1,.044.65,6.717,6.717,0,0,1,0,.768,7.44,7.44,0,0,1-.079,1.017,5.714,5.714,0,0,1-.065.585c-.022.2-.074.436-.113.633-.065.436-.2.9-.31,1.383a20.038,20.038,0,0,1-1.109,3.055,18.248,18.248,0,0,1-1.645,2.8c-.319.388-.589.781-.9,1.1l-.436.476-.436.406a8.3,8.3,0,0,1-.781.65c-.118.092-.231.175-.332.257l-.3.183a3.721,3.721,0,0,1-.567.327c-.031-.048.79-.5,1.868-1.536l.436-.41.436-.476c.305-.319.567-.711.873-1.1a19.707,19.707,0,0,0,1.61-2.771,21.181,21.181,0,0,0,1.113-3.011c.118-.476.253-.93.327-1.362.039-.214.083-.436.122-.624s.057-.393.083-.58c.061-.371.083-.707.109-1a7.607,7.607,0,0,0,.048-.759A3.542,3.542,0,0,1,419.989,241.93Z",
    transform: "translate(-325.776 -221.648)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3009",
    "data-name": "Path 3009",
    d: "M216.47,310.2l-2.121,6.075a7.489,7.489,0,0,0-1.1,5.04c.436,2.819.554,7.253,6.014,8.265s30.316-1.126,30.316-1.126S264.417,300.96,264.3,301.3a24.56,24.56,0,0,0-8.344,1.671,26.347,26.347,0,0,0-4.7,2.645,33.1,33.1,0,0,1-12.088,5.045c-4.883.982-10.338,2.086-10.15,2.086l.55-4.988Z",
    transform: "translate(-213.18 -255.106)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3010",
    "data-name": "Path 3010",
    d: "M336.433,354.623l9.548-48.409-11.241-4.1-.772-4.019-14.837,5.315-1.65-6.5-3.286,1.868-4.923.048s-14.331,19.817-15.6,31.63c-.65,6.079,2.138,20.511,2.138,20.511l-.55,11.879-1.9,5.075a2.867,2.867,0,0,0,1.226,3.84l46.258-.109a6.939,6.939,0,0,0,.589-7.292Z",
    transform: "translate(-258.209 -252.635)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3011",
    "data-name": "Path 3011",
    d: "M337.63,303.32s-2.579,5.739,0,9.361l5.189-3.369,1.161,6.175s11.407-2.269,14.768-9.112h0s-8,7.419-14.641,7.51h0l-.751-5.948-5.149,3.055S337.673,306,337.63,303.32Z",
    transform: "translate(-282.674 -256.248)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2936",
    "data-name": "Group 2936",
    transform: "translate(40.65 62.087)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3012",
    "data-name": "Path 3012",
    d: "M348.743,387.041l-28.187,6.686a3.4,3.4,0,0,1-4.1-2.527l-10.037-42.3a3.4,3.4,0,0,1,2.531-4.1l29.483-6.982a3.408,3.408,0,0,1,4.1,2.527l3.526,41.5C346.675,382.987,348.743,387.041,348.743,387.041Z",
    transform: "translate(-306.33 -337.727)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3312",
    "data-name": "Path 3312",
    d: "M4,0H33.115a4,4,0,0,1,4,4V46.281a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(41.326 67.136) rotate(-13.35)",
    fill: "#db81d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3013",
    "data-name": "Path 3013",
    d: "M352.954,380.221l.1-.035c.07-.026.179-.048.31-.1a3.544,3.544,0,0,0,2.156-2.378,3.43,3.43,0,0,0,.1-1.309c-.057-.463-.2-.951-.319-1.471l-4.224-17.569-2.9-12.145-1.593-6.747c-.275-1.161-.559-2.343-.842-3.539a7.7,7.7,0,0,0-.524-1.746,3.43,3.43,0,0,0-2.972-1.85,7.662,7.662,0,0,0-1.863.323l-3.814.908-7.855,1.868-16.535,3.928a3.443,3.443,0,0,0-2.618,2.946,5.673,5.673,0,0,0,.275,2.077c.166.694.332,1.388.493,2.077l1.907,8.134q1.9,8.012,3.648,15.409l3.334,13.943c.127.546.257,1.087.384,1.619a3.461,3.461,0,0,0,3.491,2.6,8.964,8.964,0,0,0,1.5-.288l1.475-.349,2.85-.672,17.6-4.137,4.8-1.113,1.248-.284c.279-.065.436-.092.436-.092s-.14.044-.436.113l-1.239.305-4.779,1.156L328.969,386l-2.85.681-1.475.349a8.975,8.975,0,0,1-1.532.3,3.653,3.653,0,0,1-2.9-1.248,3.723,3.723,0,0,1-.777-1.475c-.131-.537-.257-1.078-.388-1.623-1.043-4.364-2.151-9.029-3.321-13.938s-2.391-10.063-3.661-15.4q-.947-4.011-1.933-8.152c-.166-.689-.327-1.383-.493-2.077-.079-.349-.17-.689-.24-1.052a3.492,3.492,0,0,1-.044-1.1,3.67,3.67,0,0,1,.9-2.007,3.754,3.754,0,0,1,.873-.711,3.852,3.852,0,0,1,1.039-.436l16.539-3.928,7.855-1.863,3.814-.9.938-.223a3.69,3.69,0,0,1,.978-.1,3.653,3.653,0,0,1,3.151,1.964,4.011,4.011,0,0,1,.327.895c.07.3.144.6.214.9l.838,3.539,1.6,6.764c1.034,4.364,1.994,8.435,2.867,12.149,1.746,7.419,3.159,13.437,4.141,17.6.113.519.253,1,.31,1.479a3.552,3.552,0,0,1-.113,1.309,3.6,3.6,0,0,1-1.108,1.746,3.456,3.456,0,0,1-1.1.641,3.343,3.343,0,0,1-.458.153Z",
    transform: "translate(-267.372 -271.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 3.64,
    cy: 3.64,
    r: 3.64,
    transform: "translate(60.999 89.591) rotate(-80.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3014",
    "data-name": "Path 3014",
    d: "M322.993,419.35a5.29,5.29,0,0,0,3.753,2.854c2.928.777,9.387.772,10.6,1.2s25.49,5.106,25.49,5.106.58-.3.7-2.732S322.993,419.35,322.993,419.35Z",
    transform: "translate(-275.068 -321.643)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3015",
    "data-name": "Path 3015",
    d: "M324.1,366.756a.659.659,0,0,0-.969-.436,4.249,4.249,0,0,0-1.955,4.364,10.381,10.381,0,0,0,1.309,4.434l-7.419.825s-2.618.733-2.234,2.317.737,1.471.737,1.471A1.746,1.746,0,0,0,312,381.773a3.014,3.014,0,0,0,1.383,1.894s-.41,1.894-.122,2.3a8.658,8.658,0,0,0,2.055,1.178s-.353,1.222.41,1.8,4.748,1.545,4.748,1.545,8.54.436,10.356.436l8.61,1.977V382.75s-7.061-1.309-7.449-1.746c-.825-.947-5.394-7.419-5.394-7.419a12.377,12.377,0,0,1-2.134-3.832A29.134,29.134,0,0,1,324.1,366.756Z",
    transform: "translate(-268.858 -291.707)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3016",
    "data-name": "Path 3016",
    d: "M319.9,396.716a29.468,29.468,0,0,1-4.416-.044,15.713,15.713,0,0,1,2.208-.061A15.288,15.288,0,0,1,319.9,396.716Z",
    transform: "translate(-270.837 -308.82)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3017",
    "data-name": "Path 3017",
    d: "M320.49,406.427a3.49,3.49,0,0,1-.785.026c-.484,0-1.156-.039-1.9-.1s-1.41-.14-1.89-.209a3.565,3.565,0,0,1-.777-.153,3.7,3.7,0,0,1,.786.035l1.89.161,1.89.148a3.831,3.831,0,0,1,.786.092Z",
    transform: "translate(-270.645 -314.11)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3018",
    "data-name": "Path 3018",
    d: "M322.6,414.549a6.763,6.763,0,0,1-1.453-.214,6.947,6.947,0,0,1-1.418-.375,6.109,6.109,0,0,1,1.449.214A6.623,6.623,0,0,1,322.6,414.549Z",
    transform: "translate(-273.232 -318.605)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3019",
    "data-name": "Path 3019",
    d: "M382.2,318s1.331.035,3.736,3.644,9.937,34.593,10.373,37.9c.593,4.168-1.309,10.583-5.6,11.115-5.691.711-32.878-5.529-32.878-5.529l3.544-11.346,18.272,1.008s-2.453-11.468-3.426-14.4C374.622,335.513,375.648,319.973,382.2,318Z",
    transform: "translate(-294.705 -264.522)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3020",
    "data-name": "Path 3020",
    d: "M301.489,328.43a.628.628,0,0,1-.074.192l-.253.541c-.24.5-.563,1.165-.951,1.977-.79,1.671-1.846,4-2.876,6.629s-1.846,5.053-2.352,6.83c-.249.873-.436,1.619-.554,2.121-.052.231-.1.436-.14.58a.7.7,0,0,1-.061.2.562.562,0,0,1,0-.205c.026-.161.057-.358.1-.589.1-.511.257-1.248.489-2.143a62.187,62.187,0,0,1,2.291-6.873c1.034-2.618,2.117-4.957,2.946-6.616.436-.829.764-1.5,1.017-1.946.113-.21.214-.38.292-.519A.934.934,0,0,1,301.489,328.43Z",
    transform: "translate(-258.854 -270.4)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3021",
    "data-name": "Path 3021",
    d: "M360.448,305.389a2.214,2.214,0,0,1-.209.279c-.144.17-.34.436-.642.759a18.834,18.834,0,0,1-2.727,2.466,22.815,22.815,0,0,1-4.8,2.736,23.388,23.388,0,0,1-6.576,1.746h-.109v-.109l-.179-1.405c-.2-1.567-.384-3.09-.567-4.543l.166.083-5.158,3.029-.109.065-.031-.127a20.63,20.63,0,0,1-.511-5.913c.044-.711.113-1.27.17-1.645.031-.188.057-.332.074-.436a.567.567,0,0,1,.035-.144.549.549,0,0,1,0,.148c0,.113-.031.253-.048.436-.039.375-.092.93-.118,1.641a21.279,21.279,0,0,0,.585,5.865l-.14-.057,5.141-3.055.148-.083v.166c.183,1.449.38,2.972.576,4.543.061.48.122.956.175,1.4l-.122-.1a24.137,24.137,0,0,0,11.281-4.364,20.511,20.511,0,0,0,2.767-2.4c.31-.3.511-.572.672-.733A2.67,2.67,0,0,1,360.448,305.389Z",
    transform: "translate(-284.07 -255.634)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3022",
    "data-name": "Path 3022",
    d: "M243.135,336.254a1.572,1.572,0,0,1,.022-.393c.026-.253.079-.62.157-1.065a29.1,29.1,0,0,1,.842-3.456,28.329,28.329,0,0,1,1.257-3.325c.188-.41.349-.742.467-.969a1.358,1.358,0,0,1,.209-.336,12.882,12.882,0,0,1-.528,1.37c-.34.838-.777,2.012-1.187,3.33s-.707,2.531-.9,3.417A11.422,11.422,0,0,1,243.135,336.254Z",
    transform: "translate(-230.06 -269.431)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3003",
    "data-name": "Group 3003",
    transform: "translate(125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-50",
    transform: "translate(9340.945 1805.678)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_998",
    "data-name": "Rectangle 998",
    width: 18.878,
    height: 32.167,
    transform: "translate(47.844 103.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3023",
    "data-name": "Path 3023",
    d: "M166.806,395.459v-2.4c0-1.554,0-3.81-.031-6.651,0-5.673-.031-13.707-.048-23.129l.1.1H147.953l.113-.113c0,12.263-.022,23.513-.026,32.167l-.087-.087,13.755.044,3.784.022h-3.731l-13.808.048h-.087v-.087c0-8.654,0-19.9-.026-32.167V363.1h19.053v.1c0,9.439-.039,17.491-.052,23.19,0,2.832,0,5.08-.026,6.624V395.2C166.81,395.411,166.806,395.459,166.806,395.459Z",
    transform: "translate(-100.083 -260.203)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_999",
    "data-name": "Rectangle 999",
    width: 44.028,
    height: 35.156,
    rx: 2.8,
    transform: "translate(20.971 104.66)",
    fill: "#8ad7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M-9334.979-1752.173l-.256-21.363c-1.121.263-5.76.522-5.711-4.71.049-5.114,4.32-4.386,5.606-4.039l-.076-6.374c-.405-9.068,4.534-16.867,13.616-17.02l.837.035a16.237,16.237,0,0,1,15.554,15.585c.31,7.853.549,16.555.321,20.759-.474,8.707-9.236,9.71-9.236,9.71s-.054,5.3-.41,8.008l2.044,5.957-13.379,3.212Z",
    transform: "translate(9349.553 1811.822)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3025",
    "data-name": "Path 3025",
    d: "M104.668,242.068a21.044,21.044,0,0,1-11.2-3.818s2.457,6.659,11.176,6.232Z",
    transform: "translate(-69.44 -189.836)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3026",
    "data-name": "Path 3026",
    d: "M114.651,194.871a9.11,9.11,0,0,1,2.182-.3c.34-.022.668-.074.733-.305a1.746,1.746,0,0,0-.183-1.021l-.9-2.645a45.073,45.073,0,0,1-1.99-6.9,42.753,42.753,0,0,1,2.54,6.725c.3.925.585,1.811.873,2.653a1.977,1.977,0,0,1,.122,1.348.873.873,0,0,1-.585.476,2.02,2.02,0,0,1-.58.057A8.587,8.587,0,0,1,114.651,194.871Z",
    transform: "translate(-81.277 -159.091)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3028",
    "data-name": "Path 3028",
    d: "M64.229,203.539c-.026,0-.1.074-.279.153a1.039,1.039,0,0,1-.777,0,2.565,2.565,0,0,1-1.165-2.317,3.391,3.391,0,0,1,.3-1.484,1.2,1.2,0,0,1,.79-.79.532.532,0,0,1,.611.292c.079.166.039.284.07.3s.131-.1.083-.345a.633.633,0,0,0-.231-.375.777.777,0,0,0-.572-.157,1.466,1.466,0,0,0-1.1.912,3.557,3.557,0,0,0-.375,1.658,2.7,2.7,0,0,0,1.492,2.588,1.109,1.109,0,0,0,.951-.148C64.216,203.691,64.251,203.552,64.229,203.539Z",
    transform: "translate(-51.471 -167.606)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3029",
    "data-name": "Path 3029",
    d: "M95.859,146.407c-3.74.576-7.571.3-10.556-2.021a17.709,17.709,0,0,1-2.391-2.261c-1.309-1.5-2.357-3.373-4.141-4.281-2.3-1.17-5.067-.371-7.51.436l.1-.092a10.975,10.975,0,0,0-3.408,2.4,33.93,33.93,0,0,1-2.618,16.932,1.815,1.815,0,0,1-.978.969c-1.4.554-.964-1.309-2-1.658-.794-.275-1.178-.1-2.762-.153-.55-1.5-.873-5.577-1.335-7.781A10.176,10.176,0,0,1,55.7,142.95a13.066,13.066,0,0,1,1.065-4.552c1.51-2.867,2.387-4.333,4.7-5.128l.052.022c2.082-.812,4.634-.794,6.319.663.436-3.1,3.212-5.533,6.254-6.293a20.28,20.28,0,0,1,10.8.973A19.724,19.724,0,0,1,91,133.271h0c.292.3.593.607.9.93l.074.083a5.267,5.267,0,0,0,2.256.7,3.254,3.254,0,0,0,3.055-1.248c.275-.3.62-.676,1-.554a.834.834,0,0,1,.463.576,3.708,3.708,0,0,1-1.122,3.709,6.11,6.11,0,0,1-1.615,1.1,4.2,4.2,0,0,0,2.4,1.34,3.024,3.024,0,0,1,2.016,1.287,2.09,2.09,0,0,1,.384,1.165C100.8,144.888,98.294,146.031,95.859,146.407Z",
    transform: "translate(-48.15 -127.31)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    "data-name": "Path 3030",
    d: "M117.083,147.5l-.07.061-.223.153a2.775,2.775,0,0,1-.371.236,4.609,4.609,0,0,1-.532.271,7.763,7.763,0,0,1-3.744.633,9.884,9.884,0,0,1-5.237-2.007,17.063,17.063,0,0,1-4.464-5.263c-.62-1.065-1.126-2.151-1.684-3.159a11.534,11.534,0,0,0-1.92-2.675,5.917,5.917,0,0,0-2.5-1.554,4.237,4.237,0,0,0-1.309-.17,4.739,4.739,0,0,0-1.218.218,5.08,5.08,0,0,0-2.828,2.343,6.013,6.013,0,0,0-.467,1.309V137.8a2.513,2.513,0,0,1,.044-.266,4.612,4.612,0,0,1,.345-.982,4.931,4.931,0,0,1,.991-1.309,5.141,5.141,0,0,1,1.863-1.126,4.8,4.8,0,0,1,1.257-.24,4.569,4.569,0,0,1,1.375.161,6.109,6.109,0,0,1,2.583,1.584,11.839,11.839,0,0,1,1.959,2.714c.567,1.012,1.069,2.1,1.689,3.155a17.094,17.094,0,0,0,4.4,5.215,9.849,9.849,0,0,0,5.141,2.012,7.855,7.855,0,0,0,3.7-.559C116.673,147.789,117.066,147.457,117.083,147.5Z",
    transform: "translate(-67.777 -131.009)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M141.367,156.326a1.536,1.536,0,0,1-.319.214,6.112,6.112,0,0,1-.93.458,8.727,8.727,0,0,1-1.471.467,10.321,10.321,0,0,1-1.881.227,10.621,10.621,0,0,1-1.885-.148,9.081,9.081,0,0,1-1.492-.406,6.82,6.82,0,0,1-.947-.436c-.218-.118-.332-.188-.323-.2s.493.218,1.309.484a10.358,10.358,0,0,0,1.475.353,10.736,10.736,0,0,0,1.85.131,11.317,11.317,0,0,0,1.846-.205,10.91,10.91,0,0,0,1.458-.436C140.878,156.566,141.345,156.291,141.367,156.326Z",
    transform: "translate(-91.223 -143.662)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    "data-name": "Path 3032",
    d: "M69.928,166.72a1.654,1.654,0,0,1,.079.563,10.3,10.3,0,0,1-.031,1.558,5.4,5.4,0,0,1-.179,1.1.628.628,0,0,1-.6.436,1.117,1.117,0,0,1-.663-.327l-2.13-1.973.314-.183c.1.436.2.842.305,1.279.284,1.2.55,2.348.794,3.391l.131.572-.436-.4a14,14,0,0,1-2.343-2.911,4.874,4.874,0,0,1-.642-1.309,21.664,21.664,0,0,0,3.242,3.954l-.288.17c-.253-1.043-.532-2.182-.825-3.382-.1-.436-.205-.873-.305-1.283l-.144-.62.436.436,2.095,2a.873.873,0,0,0,.436.262.323.323,0,0,0,.31-.236,5.672,5.672,0,0,0,.205-1.017C69.906,167.519,69.871,166.724,69.928,166.72Z",
    transform: "translate(-53.129 -149.522)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3034",
    "data-name": "Path 3034",
    d: "M106.417,216.85a5.707,5.707,0,0,1-.628.2,4.455,4.455,0,0,1-1.746-.1h0a2.147,2.147,0,0,1-1.466-2.841,4.8,4.8,0,0,1,.436-1.148l-.227.083c1.353.506,2.544.938,3.4,1.231a6.258,6.258,0,0,0,1.4.406,6.367,6.367,0,0,0-1.309-.628c-.834-.353-2.007-.829-3.356-1.357l-.148-.057-.079.14a5.136,5.136,0,0,0-.476,1.244,2.775,2.775,0,0,0,.227,2.151,2.732,2.732,0,0,0,1.514,1.069h0a4.089,4.089,0,0,0,1.855-.022A1.057,1.057,0,0,0,106.417,216.85Z",
    transform: "translate(-74.301 -175.397)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3035",
    "data-name": "Path 3035",
    d: "M128.589,194.144a1.266,1.266,0,0,1-1.266,1.231,1.209,1.209,0,0,1-1.244-1.2,1.266,1.266,0,0,1,1.261-1.235,1.209,1.209,0,0,1,1.248,1.2Z",
    transform: "translate(-87.819 -164.299)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3036",
    "data-name": "Path 3036",
    d: "M127.2,183.963c-.161.157-1.082-.593-2.435-.646s-2.37.589-2.509.436c-.07-.074.1-.371.545-.668a3.408,3.408,0,0,1,2.016-.541,3.286,3.286,0,0,1,1.933.724C127.157,183.588,127.283,183.893,127.2,183.963Z",
    transform: "translate(-85.658 -158.438)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3037",
    "data-name": "Path 3037",
    d: "M100.089,192.844a1.261,1.261,0,0,1-1.261,1.231,1.209,1.209,0,0,1-1.248-1.2,1.266,1.266,0,0,1,1.261-1.235,1.213,1.213,0,0,1,1.248,1.2Z",
    transform: "translate(-71.756 -163.566)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3038",
    "data-name": "Path 3038",
    d: "M96.835,183.415c-.166.157-1.087-.593-2.439-.646s-2.365.589-2.5.415c-.07-.079.1-.371.545-.672a3.421,3.421,0,0,1,2.016-.519,3.286,3.286,0,0,1,1.929.72C96.782,183.036,96.913,183.341,96.835,183.415Z",
    transform: "translate(-68.541 -158.126)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3039",
    "data-name": "Path 3039",
    d: "M96.659,173.438c-.2.34-1.492-.079-3.09-.183s-2.933.1-3.081-.271c-.065-.175.218-.48.79-.738a5.062,5.062,0,0,1,2.391-.38,5.149,5.149,0,0,1,2.313.724C96.51,172.932,96.746,173.276,96.659,173.438Z",
    transform: "translate(-67.754 -152.412)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3040",
    "data-name": "Path 3040",
    d: "M127.113,174.67c-.288.3-1.383-.052-2.706-.1s-2.448.144-2.7-.188c-.109-.161.074-.471.572-.751a4.229,4.229,0,0,1,2.213-.436,4.154,4.154,0,0,1,2.143.681C127.1,174.194,127.24,174.521,127.113,174.67Z",
    transform: "translate(-85.339 -153.164)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3042",
    "data-name": "Path 3042",
    d: "M206.675,221.618s-2.54-2.025-2.714-3.229.087-2.409-.3-3.142,1.379-1.117,2.282,0,1.636,1.938,1.636,1.938.947-5.939,1.375-7.659,1.122-5.983,1.309-7.419.6-3.443,1.418-3.443h.218s.947.087.772.9c0,0,.388-4,2.326-3.871,0,0,1.2,0,1.03,1.938s-.515,4.429-.515,4.429l1.309-4.691s.127-1.462,1.418-1.248,1.122,1.379.873,3.356-1.074,6.585-1.074,6.585,1.719-5.979,2.409-6.411,1.894-.476,1.506,1.719-1.375,6.93-1.375,6.93-.262,7.571-.6,9.208-5.237,11.866-5.237,11.866L206,224.424s1.575-1.776,1.444-1.9S206.675,221.618,206.675,221.618Z",
    transform: "translate(-131.512 -165.851)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3043",
    "data-name": "Path 3043",
    d: "M212.054,244.85a9.517,9.517,0,0,1-.109,1.309,8.386,8.386,0,0,1-.092,1.309,2.619,2.619,0,0,1-.135-1.331A2.553,2.553,0,0,1,212.054,244.85Z",
    transform: "translate(-136.067 -193.556)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3044",
    "data-name": "Path 3044",
    d: "M221.273,212.054a6,6,0,0,1,.031-1.287c.057-.794.175-1.89.38-3.085a31.168,31.168,0,0,1,.659-3.055,6.877,6.877,0,0,1,.4-1.226,8.761,8.761,0,0,1-.24,1.266c-.166.772-.388,1.846-.594,3.055s-.345,2.274-.436,3.055A8.678,8.678,0,0,1,221.273,212.054Z",
    transform: "translate(-141.458 -170.195)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3045",
    "data-name": "Path 3045",
    d: "M228.537,214.325a4.01,4.01,0,0,1,0-1.034,23.069,23.069,0,0,1,.319-2.466,24.624,24.624,0,0,1,.563-2.426,3.967,3.967,0,0,1,.349-.969,5.7,5.7,0,0,1-.192,1.012c-.14.615-.323,1.471-.5,2.422s-.3,1.815-.384,2.444a5.874,5.874,0,0,1-.157,1.017Z",
    transform: "translate(-145.545 -172.466)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3046",
    "data-name": "Path 3046",
    d: "M235.639,220.9a8.068,8.068,0,0,1,.79-3.592,13.471,13.471,0,0,1-.38,1.8,14.584,14.584,0,0,1-.41,1.794Z",
    transform: "translate(-149.567 -178.035)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3048",
    "data-name": "Path 3048",
    d: "M48.9,459.72l1.6-6.69,46.947.847,2.173,5.843Z",
    transform: "translate(-44.32 -310.888)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3049",
    "data-name": "Path 3049",
    d: "M51.115,245.351c-1.135.38-13.2,11.809-12.695,25.145s6.917,54.218,6.917,54.218-5.533,2.265-3.9,7.419,50.622,3.491,50.622,3.491.467.436.676-3.522c.292-5.451-8.126-58.477-8.126-58.477S77.268,258.84,74.134,251.9l-.476-3.884L52.507,240.83Z",
    transform: "translate(-38.405 -191.291)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3050",
    "data-name": "Path 3050",
    d: "M88.38,320.54s16.347,13.821,26.965,14.733l-.79-5.145Z",
    transform: "translate(-66.571 -236.216)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3051",
    "data-name": "Path 3051",
    d: "M79,314.25a1.672,1.672,0,0,1,.31.188l.873.567c.367.253.82.559,1.362.873s1.135.742,1.824,1.148,1.427.873,2.247,1.309,1.7.938,2.618,1.436c1.876.973,3.962,1.986,6.2,2.95s4.408,1.785,6.4,2.487,3.81,1.266,5.346,1.7c.764.231,1.462.41,2.073.58s1.143.305,1.575.41l.995.262a1.923,1.923,0,0,1,.345.1,1.96,1.96,0,0,1-.353-.061l-1.008-.218c-.436-.092-.969-.218-1.584-.375s-1.309-.327-2.086-.55c-1.545-.415-3.365-.978-5.372-1.654s-4.176-1.514-6.419-2.479-4.333-1.99-6.206-2.972c-.93-.506-1.815-.978-2.618-1.462s-1.588-.864-2.265-1.3-1.279-.825-1.807-1.174-.982-.663-1.34-.93l-.834-.607A2.73,2.73,0,0,1,79,314.25Z",
    transform: "translate(-61.284 -232.671)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3052",
    "data-name": "Path 3052",
    d: "M89.743,253.643a1.912,1.912,0,0,1,.065.358c.044.257.1.6.17,1.026a35.12,35.12,0,0,0,.847,3.718l.048.175-.166-.07c-2.374-1.043-5.555-2.365-9.09-3.64-3.9-1.414-7.489-2.509-10.107-3.242l-3.107-.851-.851-.24a1.393,1.393,0,0,1-.292-.1,1.311,1.311,0,0,1,.3.052l.873.188c.742.17,1.811.436,3.129.777,2.618.7,6.24,1.767,10.146,3.186,3.548,1.279,6.72,2.618,9.086,3.7l-.118.1a30.742,30.742,0,0,1-.777-3.749c-.061-.436-.1-.8-.122-1.039A1.745,1.745,0,0,1,89.743,253.643Z",
    transform: "translate(-54.668 -196.898)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3053",
    "data-name": "Path 3053",
    d: "M57.615,432.365a9.376,9.376,0,0,1-2.007.388,9.426,9.426,0,0,1-2.038.166,8.776,8.776,0,0,1,2.007-.388,9.428,9.428,0,0,1,2.038-.166Z",
    transform: "translate(-46.952 -299.239)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3041",
    "data-name": "Path 3041",
    d: "M70.848,284.6c2.994,2.858,26.581,14.375,38.315,13.663s26.489-32.354,26.489-32.354l-11.2-6.4-2.845,4.1-16.356,16.147s-17.416-12.782-21.156-15.095-9.954-9.422-18.843-1.776S64.735,278.763,70.848,284.6Z",
    transform: "translate(-51.352 -201.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3047",
    "data-name": "Path 3047",
    d: "M109.678,286.546a.519.519,0,0,1-.048-.135l-.109-.41c-.092-.371-.223-.9-.384-1.571a15.986,15.986,0,0,0-.751-2.439,7.069,7.069,0,0,0-.768-1.383,5.673,5.673,0,0,0-1.257-1.239c-1.986-1.536-4.412-3.295-7.135-5.206s-5.734-3.98-8.846-6.232c-1.554-1.126-3.055-2.217-4.569-3.238s-2.976-1.942-4.364-2.832a12.96,12.96,0,0,0-2.138-1.108,3.653,3.653,0,0,0-1.1-.253l-.563-.061h-.554a14.2,14.2,0,0,0-4.045.5,20.861,20.861,0,0,0-5.416,2.348c-.6.362-1.056.668-1.362.873l-.349.236a.591.591,0,0,1-.127.074.69.69,0,0,1,.109-.092l.34-.253c.3-.223.742-.537,1.34-.912a20.206,20.206,0,0,1,5.429-2.453,14.109,14.109,0,0,1,4.089-.528h.563l.572.057a4.008,4.008,0,0,1,1.152.262,13.011,13.011,0,0,1,2.182,1.117c1.41.873,2.889,1.807,4.39,2.828s3.024,2.112,4.582,3.238c3.107,2.247,6.11,4.32,8.833,6.245s5.132,3.692,7.113,5.237a5.817,5.817,0,0,1,1.274,1.283,7.2,7.2,0,0,1,.768,1.418,15.645,15.645,0,0,1,.72,2.466c.144.676.257,1.209.34,1.584.035.17.065.306.087.41A.62.62,0,0,1,109.678,286.546Z",
    transform: "translate(-53.839 -202.222)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3466",
    "data-name": "Path 3466",
    d: "M9394.785,1883.6s16.354-15.967,16.482-16.053,3.091-4.12,3.091-4.12l10.945,6.567-10.9,18.843s-8.886,13.907-15.023,13.478a93.024,93.024,0,0,1-10.129-1.2",
    fill: "none",
    stroke: "#25292b",
    strokeLinecap: "round",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporationCard);
export default __webpack_public_path__ + "static/media/corporation_card.11a40e540092e03ec771c0045adb5271.svg";
export { ForwardRef as ReactComponent };